export { default } from "./getSuffix";
